// Help component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../common/icon_button/icon_button.jsx'
import Button from '../../common/button/button.jsx'
import HelpContent from '../help_content/help_content.jsx'
import HelpPointer from '../help_pointer/help_pointer.jsx'
import Player from '../../player/player.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class Help extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      tipIndex: 0,
      bAnimateCont: true
    }

    this._references = {
      refVideoPlayer: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func,
      info: PropTypes.object,
      onClick: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onClose: null,
      info: null,
      onClick: null
    }
  }

  render () {
    const _className = classnames('help', {
      help_active: this.state.active
    })

    return (
      <div className={_className}>
        <div className='helpclose'>
          <IconButton
            icon='header-search-close'
            title='common.help.closeHelpTitle'
            canHover={false}
            onClick={this._onClickClose.bind(this)}
          />
        </div>
        <div className='helpwrap'>
          {this._renderInfo()}
          <div className='helpbuttons'>
            {this._renderCloseButton()}
            {this._renderNextTipButton()}
            {this._renderVideoButton()}
          </div>
        </div>
        {this._renderPointers()}
        <Player ref={this._references.refVideoPlayer} />
      </div>
    )
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({ active: false, tipIndex: 0, bAnimateCont: true })
  }

  /* Event handlers */
  _onClickClose (ev) {
    ev.preventDefault()

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onClickVideo (ev) {
    ev.preventDefault()
    if (this._references.refVideoPlayer.current) {
      this._references.refVideoPlayer.current.show(this.props.info.videoUrl)
    }
  }

  _onClickNextTip (ev) {
    ev.preventDefault()

    let index = this.state.tipIndex
    index++
    this.setState({ tipIndex: index, bAnimateCont: !this.state.bAnimateCont })
  }

  _onClickPointer (index, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this.setState({ tipIndex: index, bAnimateCont: !this.state.bAnimateCont })
  }

  /* Private functions */
  _renderInfo () {
    if (
      this.props.info &&
      this.props.info.tips &&
      this.props.info.tips.length > 0
    ) {
      const tipInfo = this.props.info.tips[this.state.tipIndex]

      return (
        <HelpContent
          content={tipInfo.content}
          bAnimate={this.state.bAnimateCont}
        />
      )
    }

    return null
  }

  _renderCloseButton () {
    const index = parseInt(this.state.tipIndex + 1, 10)
    if (
      this.props.info.tips.length === 0 ||
      this.props.info.tips.length === index
    ) {
      return (
        <Button
          className='button_help'
          title='common.help.closeButton'
          type='button'
          icon='dialog-close'
          onClick={this._onClickClose.bind(this)}
        />
      )
    }

    return null
  }

  _renderNextTipButton () {
    const index = parseInt(this.state.tipIndex + 1, 10)
    if (
      this.props.info.tips.length > 0 &&
      index < this.props.info.tips.length
    ) {
      return (
        <Button
          className='button_help button_nexttip'
          title='common.help.nextTip'
          type='button'
          icon='help-tip-next'
          onClick={this._onClickNextTip.bind(this)}
        />
      )
    }

    return null
  }

  _renderVideoButton () {
    if (this.props.info && this.props.info.videoUrl) {
      return (
        <Button
          className='button_help button_video'
          title='common.help.showVideo'
          type='button'
          iconHover={false}
          icon='help-video-play'
          onClick={this._onClickVideo.bind(this)}
        />
      )
    }

    return null
  }

  _renderPointers () {
    if (this.props.info.tips && this.props.info.tips.length > 0) {
      return this.props.info.tips.map((tip, i) => {
        if (tip.value) {
          return (
            <HelpPointer
              key={i}
              value={tip.value}
              type={tip.pointerType}
              position={tip.location}
              onClick={this._onClickPointer.bind(this, i)}
              showActive={i === this.state.tipIndex}
            />
          )
        }
        return ''
      })
    }

    return null
  }
}

export default Help
